import CurrencyList from './currency-list';

export default CurrencyList;
